module.exports = __webpack_public_path__ + "static/media/bolt_118.c6e889ea.png";